import { render } from "./ClaimFR.vue?vue&type=template&id=4059d84b&scoped=true"
import script from "./ClaimFR.vue?vue&type=script&lang=js"
export * from "./ClaimFR.vue?vue&type=script&lang=js"

import "./ClaimFR.vue?vue&type=style&index=0&id=4059d84b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059d84b"]])

export default __exports__